<template>
  <div>
    <v-card-text>
      <v-form @submit.prevent="save" ref="form" :disabled="disableForm">
        <v-container>
          <CirurgyForm
            :realized.sync="realized"
            :captationsForm="captationsForm"
            :formRules="formRules"
            :maxDateTime="maxDateTime"
            :isPCRDonor="isPCRDonor"
            :captureOnlyCorneas="captureOnlyCorneas"
            :reasonCaptations="reasonsForNotCapture"
            :isFamilyReason.sync="isFamilyReason"
            :typeSurgery="typeSurgery"
          />

          <RazaoNaoCaptacaoCard
            v-if="showPartialCaptationReason"
            :captationsForm="captationsForm"
            :reasonsForNotCapture="reasonsForNotCapture"
            :formRules="formRules"
            :realized="realized"
            :clearValidation="clearValidation"
          /> 

          <v-row dense v-if="hasCapturedAny">  
            <v-col cols="12" v-for="field in orgons" :key="field.id">
              <OrgonsCapturedsForm
                :field="field"
                :solucoes="solucoes"
                :yesorNot="yesorNot"
                :formRules="formRules"
                :dateRules="dateRules"
                :maxDateForOrgonsCaptation="maxDateForOrgonsCaptation"
                :minDateForOrgonsCaptation="minDateForOrgonsCaptation"
                :maxDateToLoteValidation="maxDateToLoteValidation"
                :surgicalDescriptions="surgical_descriptions"
                :reasonsForNotCapturedOrgons="reasons_for_not_captured_orgons"
                :reasonsForNotCapturedTissues="reasons_for_not_captured_tissues"
                @block-selection-changed="handleBlockSelection"
              />
            </v-col>
          </v-row>

          <v-row dense v-if="showFabricConditioning">
            <v-col cols="12">
              <AcondicionamentoColeta
                :fabricConditioning="fabric_conditioning"
                :fabricConditionings="fabric_conditionings"
                :selectedFabricConditionings.sync="selectedFabricConditionings"
                :bloodCollection="bloodCollection"
                :bloodSampleCollections="blood_sample_collections"
                :profile="profile"
                :formRules="formRules"
              />
            </v-col>
          </v-row>

          <v-row dense class="d-flex justify-space-between mt-8"> 
            <v-col class="d-flex" cols="12" sm="auto">
              <v-btn
                block
                class="rounded-lg ml-1"
                elevation="0"
                color="#89ab9b"
                @click="$emit('changeTab', turnBackTab)"
              >
                <span style="color: white">{{$t('buttons.return')}}</span>
              </v-btn>
            </v-col> 
            <v-col class="d-flex" cols="12" sm="auto">
              <v-btn
                data-cy="btn-save-captacao"
                block
                :loading="loading"
                class="rounded-lg ml-1"
                elevation="0"
                color="#41916b"
                @click="save()"
                v-if="!disableForm"
              >
                <span style="color: white">{{$t('buttons.save')}}</span>
              </v-btn> 
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

    <v-dialog v-model="blockModal" persistent max-width="1000">
      <OrgonBlockModal
        :group="currentBlockGroup"
        :dateRules="dateRules"
        :maxDateForOrgonsCaptation="maxDateForOrgonsCaptation"
        :minDateForOrgonsCaptation="minDateForOrgonsCaptation"
        @save="getBlockData($event)"
        @cancel="blockModal = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import {
  getTypeSurgery,
  getOrgonsList,
  getPreservationSolutions,
  getBloodCollection,
  getFabricConditionings,
  getSurgicalDescriptions,
  getReasonsCaptations,
  getReasonsForOrgons,
} from "@/service/CaptationFieldsService";
import currentUser from "@/utils/currentUser";
import { profileSlug } from "@/helpers/profileSlug";
import OrgonBlockModal from "./OrgonBlockModalForm.vue";
import OrgonsCapturedsForm from "./OrgonsCapturedsForm.vue";
import AcondicionamentoColeta from "./AcondicionamentoColetaForm.vue";
import CirurgyForm from "./CirurgyForm.vue";
import RazaoNaoCaptacaoCard from "./RazaoNaoCaptacaoCard.vue";
import { buildPayload, getOrgonGroup } from "./builder/captacaoBuilder";
import { ORGON_GROUPS, YES_OR_NOT } from "./constants/captacaoConstants";
import { captacaoFillsMixin } from "./mixins/captacaoFillsMixin";
import Formatters from "@/utils/Formatters";
import {compareStr} from "@/utils/compareStrings";
export default {
  components: { OrgonBlockModal, OrgonsCapturedsForm, AcondicionamentoColeta, CirurgyForm, RazaoNaoCaptacaoCard },
  mixins: [captacaoFillsMixin],

  data() {
    return {
      loading: false,
      orgons: [],
      solucoes: [],
      formRules: [(v) => !!v || "Este campo é obrigatório"],
      dateRules: [
        v => !!v || 'Campo obrigatório',
        v => {
          if (!v || !this.captationsForm.start_surgery || !this.captationsForm.end_surgery) return true;
          const c = new Date(v);
          const start = new Date(this.captationsForm.start_surgery);
          const end = new Date(this.captationsForm.end_surgery);
          if (c < start) return 'A data/hora da captação não pode ser anterior ao início da cirurgia';
          if (c > end) return 'A data/hora da captação não pode ser posterior ao término da cirurgia';
          return true;
        }
      ],
      captationsForm: { reasonsForNotCaptureId: null },
      realized: "",
      reason_captations: [],
      reason_orgons: [],
      continueButton: false,
      disableForm: false,
      fabric_conditioning: {},
      bloodCollection: {},
      blood_sample_collections: [],
      fabric_conditionings: [],
      surgical_descriptions: [],
      selectedFabricConditionings: [],
      typeOrgonId: null,
      reasons_for_not_captured_tissues: [],
      reasons_for_not_captured_orgons: [],
      isFamilyReason: false,
      blockModal: false,
      currentBlockGroup: null,
      blockDataForm: {},
      typeSurgery: [],
      reasonsForNotCapture: [],
      isInitializingFormData: false,
      clearValidation: false
    };
  },

  watch: {
    'realized': {
      async handler(currentCaptationType) { 
        await this.handleRealizedChange(currentCaptationType);
        this.getReasonForNonCaptations();
      },
      deep: true
    },  
  },

  async created() {
    await this.loadFormDependencies();
    this.initializeForm();
    await this.getReasonsByOrgonType();
  },
  
  computed: {
    ...mapGetters({
      resource: "getPatientData",
      captation: "getCaptationData",
    }),

    captureOnlyCorneas() {
      return this.resource.encerramento_pme?.[0]?.tissue_harvesting_only_flg === 'SIM';
    },

    isPCRDonor() {
      return this.resource.kind_of_donor === 'PCR';
    }, 

    turnBackTab(){
      return this.isPCRDonor ? 1 : 0;
    },

    nextTab(){
      return this.isPCRDonor ? 3 : 2;
    },

    orgonByCirurgyType() {
      let kindOfOrgon = ''

      if(this.realized === 'captou-orgao-e-tecidos') {
        kindOfOrgon = '';
      } else if(this.realized === 'captou-apenas-orgaos') {
        kindOfOrgon = 'orgão';
      } else if(this.realized === 'captou-apenas-tecidos') {
        kindOfOrgon = 'tecido';
      }

      return kindOfOrgon ?? '';
    },
  
    isEdit() {
      return !!this.resource.captation_id;
    },

    currentUser() {
      return currentUser.getUserData();
    },

    profile() {
      return this.currentUser.profile;
    },

    profile_slug() {
      return profileSlug(this.profile);
    },

    hasCorneas() {
      return this.orgons.some(
        orgon => (orgon.name === "CÓRNEA DIREITA" || orgon.name === "CÓRNEA ESQUERDA") &&
             orgon.orgon_captured_status_id === "captado"
      );
    },

    showPartialCaptationReason() {
      return ['captou-apenas-orgaos', 'captou-apenas-tecidos'].includes(this.realized) && !this.isPCRDonor;
    },

    isFamilyWithdrawal() {
      return this.captationsForm.reasonsForNotCaptureId === 'Desistência Familiar';
    },

    hasCapturedAny() {
      return ['captou-apenas-tecidos', 'captou-apenas-orgaos', 'captou-orgao-e-tecidos'].includes(this.realized);
    },

    showFabricConditioning() {
      return this.hasCorneas && ['captou-apenas-tecidos', 'captou-orgao-e-tecidos'].includes(this.realized);
    },

    maxDateTime() {
      return new Date().toISOString().slice(0, 16);
    },

    maxDateToLoteValidation() {
      return new Date('2060-01-01').toISOString().slice(0, 10);
    },

    maxDateForOrgonsCaptation() {
      if (!this.captationsForm || !this.captationsForm.end_surgery) return null;
      return this.captationsForm.end_surgery.slice(0, 16);
    },

    minDateForOrgonsCaptation() {
      if (!this.captationsForm || !this.captationsForm.start_surgery) return null;
      return this.captationsForm.start_surgery.slice(0, 16);
    },

    yesorNot() {
      return YES_OR_NOT;
    },
  },

  methods: {
    ...mapActions(["changeCaptationData", "changeSnackBarData", "changeKidneyData"]),

    async handleRealizedChange(currentCaptationType) {
      if (this.isInitializingFormData) return;

      if(!compareStr(currentCaptationType, "naohouvecaptacao")) {
        this.clearNonCaptureReasonFields();
      }

      if(this.hasCapturedAny) {
        await this.getOrgonList();
        await this.getReasonsByOrgonType();
        return;
      }

      this.orgons = [];
    },

    clearNonCaptureReasonFields() {
      this.captationsForm.reason_not_captured_id = null;
      this.captationsForm.reason_not_captured = null;
      this.captationsForm.reasonsForNotCaptureId = null;
      this.captationsForm.family_reason_description = null;
      this.isFamilyReason = false;
      this.clearValidation = true;
    },

    getBlockData(data) {
      this.blockDataForm = { ...this.blockDataForm, [this.currentBlockGroup]: data };
 
      var group = this.currentBlockGroup;
      var sharedFields = {
        captation_hour: data.captation_hour,
        biopsy: data.biopsy,
        packed: data.packed,
        preservation_solutions_id: data.preservation_solutions_id,
        number_lot: data.number_lot,
        lot_expiration_date: data.lot_expiration_date,
      };
       
      this.orgons.forEach(orgon => {
        var orgonSlug = (orgon.orgon && orgon.orgon.slug) || orgon.slug;
        if (ORGON_GROUPS[group] && ORGON_GROUPS[group].includes(orgonSlug)) {
          Object.assign(orgon, sharedFields);
          if (orgonSlug === 'rim-esquerdo' && data.nephrectomy_left) {
            Object.assign(orgon, data.nephrectomy_left);
          }
          if (orgonSlug === 'rim-direito' && data.nephrectomy_right) {
            Object.assign(orgon, data.nephrectomy_right);
          }
        }
      });
    },

    handleBlockSelection(field) {
      const fieldSlug = (field.orgon && field.orgon.slug) || field.slug;
      const group = getOrgonGroup(fieldSlug);

      if (field.orgon_captured_status_id !== 'captado-em-bloco') {
        if (group) this.resetBlockGroup(group);
        return;
      }

      if(!group) return;
 
      this.orgons.forEach(orgon => {
        const orgonSlug = (orgon.orgon && orgon.orgon.slug) || orgon.slug;
        if (ORGON_GROUPS[group].includes(orgonSlug)) {
          orgon.orgon_captured_status_id = 'captado-em-bloco';
          orgon.disabled = orgonSlug !== fieldSlug;
        }
      });

      this.currentBlockGroup = group;
      this.blockModal = true;
    },

    resetBlockGroup(pair) { 
      this.orgons.forEach(orgon => {
        const orgonSlug = (orgon.orgon && orgon.orgon.slug) || orgon.slug;
        if (ORGON_GROUPS[pair].includes(orgonSlug)) {
          orgon.disabled = false;
          if (orgon.orgon_captured_status_id === 'captado-em-bloco') {
            orgon.orgon_captured_status_id = null;
          }
        }
      });
      this.currentBlockGroup = null;
    },

    async getOrgonList() {
      const orgons = await getOrgonsList(this.orgonByCirurgyType); 
      this.orgons = orgons.map(function(orgon) {
        return Object.assign({
          orgon_captured_status_id: null,
          disabled: false,
          captation_hour: null,
          biopsy: null,
          packed: null,
          preservation_solutions_id: null,
          number_lot: null,
          lot_expiration_date: null,
          reason_not_captured_id: null,
          normal_morphology: null,
          single_arterial_pedicle: null,
          single_venous_pedicle: null,
          single_ureteral_rout: null,
          adequate_perfusion: null,
        }, orgon);
      });
    },

    async getReasonForNonCaptations() {
      const type = this.typeSurgery.find(type => type.slug == this.realized);
      const typeId = type ? type.id : null;
  
      this.reasonsForNotCapture = await getReasonsCaptations(typeId); 
    },

    async loadFormDependencies() { 
      const [typeSurgery, solucoes, reasonCaptations, bloodCollections, fabricConditionings, surgicalDescriptions] =
        await Promise.all([getTypeSurgery(), getPreservationSolutions(), getReasonsCaptations(),
          getBloodCollection(), getFabricConditionings(), getSurgicalDescriptions()
        ]);
 
      this.typeSurgery = typeSurgery;
      this.solucoes = solucoes;
      this.reason_captations = reasonCaptations; 
      this.blood_sample_collections = bloodCollections;
      this.fabric_conditionings = fabricConditionings;
      this.surgical_descriptions = surgicalDescriptions;
    },

    async getReasonsByOrgonType() {
      let foundOrgon = this.orgons.find(function(orgon) {
        let typeOrgon = (orgon.orgon && orgon.orgon.type_orgon) || orgon.type_orgon;
        return typeOrgon && typeOrgon.description === 'Orgão';
      });
      let foundTissue = this.orgons.find(function(orgon) {
        let typeOrgon = (orgon.orgon && orgon.orgon.type_orgon) || orgon.type_orgon;
        return typeOrgon && typeOrgon.description === 'Tecido';
      });

      let toOrgon = foundOrgon ? ((foundOrgon.orgon && foundOrgon.orgon.type_orgon) || foundOrgon.type_orgon) : null;
      let toTissue = foundTissue ? ((foundTissue.orgon && foundTissue.orgon.type_orgon) || foundTissue.type_orgon) : null;

      let typeOrgonId = toOrgon ? toOrgon.id : null;
      let typeTissueId = toTissue ? toTissue.id : null;

      this.reasons_for_not_captured_orgons = await getReasonsForOrgons(typeOrgonId);
      this.reasons_for_not_captured_tissues = await getReasonsForOrgons(typeTissueId);
    },

    initializeForm() {
      this.isInitializingFormData = true;
      const captation = this.captation || {};
      this.captationsForm = { type_captation: captation.type_captation };
      this.fillCaptationForm(captation);
      this.fillOrgonsForm(captation);
      this.$nextTick(() => {
        this.isInitializingFormData = false;
      });
      if(["transp-efetivado"].includes(this.resource.donor_status_slug)) {
        this.disableForm = true;
      }
    }, 

    validateForm() {
      const isValid = this.$refs.form.validate();
      if (!isValid) {
        this.changeSnackBarData({
          status: true, type: "erro",
          titleMessage: "Preencher todos os campos obrigatórios",
          bodyMessage: "Por favor, preencha todos os campos obrigatórios antes de salvar.",
          cardColor: "red", titleIcon: "mdi-close-circle",
        });
        setTimeout(() => this.closeSnackBar(), 5000);
      }
      return isValid;
    },

    build() { 
      const idTypeCaptation = this.typeSurgery.find(type => type.slug === this.realized)?.id || null;
      const selectedReason = this.reasonsForNotCapture.find(reason =>
        Number(reason.id) === Number(this.captationsForm.reason_not_captured_id) ||
        reason.description === this.captationsForm.reasonsForNotCaptureId
      );

      this.captationsForm.reason_not_captured_id = selectedReason?.id || null;
      this.captationsForm.reasonsForNotCaptureId = selectedReason?.description || null;
      this.captationsForm.reason_not_captured = this.captationsForm.reason_not_captured ?? this.captationsForm.family_reason_description ?? null;
      this.captationsForm.family_reason_description = this.captationsForm.family_reason_description ?? this.captationsForm.reason_not_captured ?? null;

      return buildPayload({
        type_captation_id: idTypeCaptation,
        realized: this.realized,
        captationsForm: this.captationsForm,
        orgons: this.orgons,
        fabric_conditioning: this.fabric_conditioning,
        selectedFabricConditionings: this.selectedFabricConditionings,
        bloodCollection: this.bloodCollection,
        blockDataForm: this.blockDataForm,
        resource: this.resource,
        currentUser: this.currentUser,
        captation: this.captation,
        isEdit: this.isEdit,
      });
    },

    async save() {
      if (!this.validateForm()) return;

      this.loading = true;
      const payload = this.build();

      try {
        const response = await axios({
          method: this.resource.captation_id ? "PUT" : "POST",
          url: this.resource.captation_id
            ? `/captation/${this.resource.captation_id}`
            : `/captation/create`,
          data: payload
        });
        this.handleSuccess(response);
      } catch (err) {
        this.handleError(err);
      } finally {
        this.loading = false;
      }
    },

    handleSuccess(response) {
      this.disableForm = true;
      this.changeSnackBarData({
        status: true, type: "success",
        titleMessage: response.data.message,
        bodyMessage: "", cardColor: "#41916b",
        titleIcon: "mdi-checkbox-marked-circle",
      });

      if(compareStr(this.realized, "naohouvecaptacao")) {
        this.$emit("disableCaptationTeam", true);
        setTimeout(() => {
          this.closeSnackBar();
          this.$router.push("/pacientes");
        }, 3000);
        return;
      }
 
      if (!this.resource.captation_id) {
        this.captationId = this.resource.captation
          ? this.resource.captation.id
          : response.data.id.captation.id;
      }
 
      setTimeout(() => {
        this.closeSnackBar();
        this.$emit("changeTab", this.nextTab);
        this.$emit("captationId", this.captationId);
        this.$emit("typeCaptation", this.realized);
      }, 4000);
    }, 
    
    handleError(err) { 
      this.loading = false; 
      this.changeSnackBarData({
        status: true, type: "erro",
        titleMessage: err.error,
        bodyMessage: Formatters.formatErrorMessage(err),
        cardColor: "red", titleIcon: "mdi-close-circle",
      });
      setTimeout(() => this.closeSnackBar(), 5000);
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false, 
        type: "", 
        titleMessage: "",
        bodyMessage: "",
        cardColor: "", 
        titleIcon: "",
      });
    },
  },
};
</script>